import { render, staticRenderFns } from "./Form01_153.vue?vue&type=template&id=6582530a&scoped=true&"
import script from "./Form01_153.vue?vue&type=script&lang=js&"
export * from "./Form01_153.vue?vue&type=script&lang=js&"
import style0 from "./Form01_153.vue?vue&type=style&index=0&id=6582530a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582530a",
  null
  
)

export default component.exports